import {http, onSuccess, onFail} from "./http";

// Pages
export const pages = (eventKey, params) =>
    http.get(`/api/cp/event/${eventKey}/pages`, params)
        .then(onSuccess, onFail);

export const pagesList = (eventKey, params) =>
    http.get(`/api/cp/event/${eventKey}/pages/list`, params)
        .then(onSuccess, onFail);

export const pagesDetails = (pageId, params) =>
    http.get(`/api/cp/event/pages/${pageId}`, {params})
        .then(onSuccess, onFail);

export const pagesCreate = (eventKey, pageType) =>
    http.post(`/api/cp/event/${eventKey}/pages`, {pageType})
        .then(onSuccess, onFail);

export const pagesUpdate = (page) =>
    http.post(`/api/cp/event/pages/${page.id}`, page)
        .then(onSuccess, onFail);

export const pagesSort = (eventKey, payload) =>
    http.post(`/api/cp/event/${eventKey}/pages/sort`, {sortOrder: payload})
        .then(onSuccess, onFail);

export const pagesSettingsUpdate = (pageId, payload) => 
    http.post(`/api/cp/event/pages/${pageId}/settings`, payload)
        .then(onSuccess, onFail);

export const pagesDelete = (pageId) =>
    http.delete(`/api/cp/event/pages/${pageId}`)
        .then(onSuccess, onFail);

// Blocks
export const blockCreate = (pageId, payload) =>
    http.post(`/api/cp/event/pages/${pageId}/blocks`, payload)
        .then(onSuccess, onFail);

export const blocksOrderUpdate = (pageId, payload) =>
    http.post(`/api/cp/event/pages/${pageId}/blocks/sort`, payload)
        .then(onSuccess, onFail);

export const blockPropertiesUpdate = (blockId, payload) =>
    http.post(`/api/cp/event/pages/blocks/${blockId}`, payload)
        .then(onSuccess, onFail);

export const blockDelete = (blockId) =>
    http.delete(`/api/cp/event/pages/blocks/${blockId}`)
        .then(onSuccess, onFail);
